module.exports = __webpack_public_path__ + "img/pic17.888882c1.png";